export default function commafy(amount: string | number): string {
    const COMMA_SYMBOL = ",";
    const SEGMENT_LENGTH = 3;
    const BASE_10 = 10;

    const amountIsNegative = amount < 0;
    const absoluteAmount = Math.abs(typeof amount === "string" ? parseInt(amount, BASE_10) : amount);

    const amountAsString = String(absoluteAmount);
    const length = amountAsString.length;
    const segments = Math.ceil(length / SEGMENT_LENGTH);

    const parts: string[] = [];
    for (let x = 1; x <= segments; x++) {
        const startPosition = length - (x * SEGMENT_LENGTH);
        const endPosition = startPosition + SEGMENT_LENGTH;
        const segment = amountAsString.substring(startPosition, endPosition);

        parts.unshift(segment);
    }

    return (amountIsNegative ? "-" : "") + parts.join(COMMA_SYMBOL);
}



// WEBPACK FOOTER //
// ./src/utils/commafy.ts